import React, { useRef } from "react";
import { Box, Flex } from "rebass";
import { BsCheckLg } from "react-icons/bs";
import { getLocalizedString } from "../../utils/getLocalizedString";

const SendOrderView = () => {
  const anchorRef = useRef();

  function goToMyOrder() {
    anchorRef.current.click();
  }

  return (
    <Flex
      width="100svw"
      height="100svh"
      bg="#f2f2f2"
      flexDirection="column"
      style={{ position: "fixed", left: 0, top: "50px", zIndex: 5 }}
      p="10px"
      alignItems="center"
    >
      <Flex
        bg="#464646"
        width="50px"
        height="50px"
        mt="60px"
        style={{ borderRadius: "25px" }}
        justifyContent="center"
        alignItems="center"
      >
        <BsCheckLg color="white" size="32px" />
      </Flex>
      <Box mt="20px" sx={{ fontSize: "22px", textAlign: "center" }}>
        {getLocalizedString("ORDINE INVIATO CORRETTAMENTE")}
      </Box>
      <Flex mt="90px" width={1} justifyContent="center">
        <button
          style={{
            color: "white",
            backgroundColor: "#909090",
            borderRadius: "5px",
            height: "50px",
            width: "90%",
          }}
          onClick={goToMyOrder}
        >
          {getLocalizedString("GO_TO_MY_ORDERS")}
        </button>
        <a
          ref={anchorRef}
          href={`/orders/${localStorage.getItem("selectedCustomer")}`}
          style={{ display: "none" }}
        >
          orders
        </a>
      </Flex>
    </Flex>
  );
};

export default SendOrderView;
